import { React, useState, useEffect, useRef } from "react";
import * as ReactDOM from "react-dom";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
  GridPageChangeEvent,
} from "@progress/kendo-react-grid";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import {
  Menu,
  MenuItem,
  MenuItemLink,
  MenuSelectEvent,
} from "@progress/kendo-react-layout";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";

import { useNavigate } from "react-router-dom";

const initialSort: any[] = [
  {
    field: "infoGroupName",
    dir: "asc",
  },
];

interface MachineInfoGridProps {
  data?: any | null;
  currentColumns: any;
}

const MachineInfosGrid = (props: MachineInfoGridProps) => {
  const initialDataState: { skip: number; take: number } = {
    skip: 0,
    take: 10,
  };
  const [data, setData] = useState(props.data);
  const [sort, setSort] = useState(initialSort);
  const [filter, setFilter] = useState<any>();

  const [isPagable, updateIsPagable] = useState();
  const [pageSizeValue, setPageSizeValue] = useState();
  const [page, setPage] = useState({
    skip: 0,
    take: 15,
  });
  const pageChange = (event: GridPageChangeEvent) => {
  //  console.log(event);
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take = event.page.take;

    setPage({
      ...event.page,
      take,
    });
  };

  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  const filterChange = (event: any): void => {
    if (props.data != null) {
      setData(filterBy(props.data, event.filter));
      setFilter(event.filter);
    }
  };

  const statusCell = (props: any) => {
    let statusString = "";
    const statuses: any = [
      { Id: "0", Name: "In progress" },
      { Id: "1", Name: "Finished" },
      { Id: "5", Name: "Sent" },
      { Id: "3", Name: "Closed" },
    ];
    for (var i = 0; i < statuses.length; i++) {
      if (props.dataItem.reportStatus == statuses[i].Id) {
        return <td>{statuses[i].Name}</td>;
      }
    }
    return <td></td>;
  };

  const renderExtraColumns = () => {
   // console.log(props.currentColumns);
    const columns: any = props.currentColumns;
    const renderedColumns = columns.map((column: any) => (
      <Column
        key={column.title} // Provide a unique key for each element
        field={column.field}
        title={column.title}
        filter="text"
      />
    ));
    return renderedColumns;
  };

  const _export = useRef<ExcelExport | null>(null);
  const excelExport = (event: MenuSelectEvent) => {
    if (event.item.text === "Export to Excel") {
      if (_export.current !== null) {
        _export.current.save();
      }
    }
  };

  const linkRender = (props: any) => {
    return (
      <MenuItemLink url={props.item.url} opened={props.opened}>
        {[renderMenuIconIfApplicable(props), props.item.text, null]}
      </MenuItemLink>
    );
  };

  function renderMenuIconIfApplicable(props: any) {
    return props.item.icon ? (
      <span
        style={{ fontSize: "16px" }}
        className={`k-icon k-i-${props.item.icon}`}
        role="presentation"
        key="0"
      />
    ) : null;
  }
  const pageOptions = () => {
    var obj: any = {
      buttonCount: 4,
      pageSizes: [5, 10, 15, 20, "All"],
      pageSizeValue: pageSizeValue,
    };
    return obj;
  };
  return (
      <div style={{ height: "calc(100% - 100px)", position: "relative" }}>
          <div>
              Showing filtered {data.length} rows of {props.data.length}
          </div>
      <div
        style={{
          position: "absolute",
          top: "-20px",
          left: "-20px",
        }}
          >

        <Menu openOnClick={true} onSelect={excelExport} linkRender={linkRender}>
          <MenuItem
            text=""
            icon="more-horizontal"
            data={{}}
            cssStyle={{ color: "black" }}
          >
            <MenuItem text="Export to Excel" />
          </MenuItem>
        </Menu>
      </div>
      <ExcelExport data={data} ref={_export}>
        <Grid
          data={orderBy(data, sort).slice(page.skip, page.take + page.skip)}
          skip={page.skip}
          take={page.take}
          resizable={true}
          scrollable={"virtual"}
          total={data.length}
          filterable={true}
          filter={filter}
          onFilterChange={filterChange}
          sortable={true}
          sort={sort}
          onSortChange={(e: any) => {
            setSort(e.sort);
          }}
          style={{
            width: "100%",
            height: "100%",
          }}
          pageable={false}
          onPageChange={pageChange}
        >
         
          {renderExtraColumns()}
        </Grid>
      </ExcelExport>
    </div>
  );
};

export default MachineInfosGrid;
